import { render, staticRenderFns } from "./cardMain.vue?vue&type=template&id=5e236161&scoped=true&"
import script from "./cardMain.vue?vue&type=script&lang=babel&"
export * from "./cardMain.vue?vue&type=script&lang=babel&"
import style0 from "./cardMain.vue?vue&type=style&index=0&id=5e236161&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e236161",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VCardText,VCheckbox,VList,VListItem,VListItemContent,VListItemSubtitle,VListItemTitle})
